module.exports = __webpack_public_path__ + "img/11.c827f2c8.png";